import React from 'react';
import { 
    Breadcrumb, 
    BreadcrumbItem, 
    BreadcrumbDivider, 
    makeStyles,
    tokens,
} from '@fluentui/react-components';
import { Link, useLocation } from 'react-router-dom';
import useStore from '../../store';

const useStyles = makeStyles({
    container: {
        padding: tokens.spacingVerticalS,
        backgroundColor: tokens.colorNeutralBackground1,
        borderBottom: `1px solid ${tokens.colorNeutralStroke1}`,
    },
    breadcrumb: {
        maxWidth: '1200px',
        margin: '0 auto',
        width: '100%',
    },
    link: {
        textDecoration: 'none',
        color: tokens.colorNeutralForeground1,
        ':hover': {
            textDecoration: 'underline',
        },
    },
    breadcrumbs: {
        padding: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalL}`,
        backgroundColor: tokens.colorNeutralBackground1,
        borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    },
});

export const Breadcrumbs: React.FC = () => {
    const styles = useStyles();
    const location = useLocation();
    const { userMediaList } = useStore();

    const pathElements = location.pathname.split('/').filter(Boolean);
    
    // Find media title if we're on a media page
    const mediaId = pathElements[1];
    const mediaEntry = mediaId ? userMediaList.find(entry => entry.id.toString() === mediaId) : null;

    const breadcrumbs = [
        { text: 'Home', path: '/' },
        ...pathElements.map((path, index) => {
            if (path === mediaId && mediaEntry) {
                return {
                    text: mediaEntry.title.english || mediaEntry.title.romaji,
                    path: location.pathname
                }
            }
            return {
                text: path.charAt(0).toUpperCase() + path.slice(1),
                path: '/' + pathElements.slice(0, index + 1).join('/')
            };
        })
    ];

    const handleNavigate = (path: string) => {
        // Store current scroll position
        const currentPath = window.location.pathname;
        sessionStorage.setItem(`scroll_${currentPath}`, window.scrollY.toString());

        // For home navigation, always reset scroll
        if (path === '/') {
            sessionStorage.removeItem('scroll_/');
        }
    };

    return (
        <nav className={styles.breadcrumbs} aria-label="Breadcrumb">
            <Breadcrumb className={styles.breadcrumb} size="small">
                {breadcrumbs.map((crumb, index) => (
                    <React.Fragment key={crumb.path}>
                        {index > 0 && <BreadcrumbDivider />}
                        <BreadcrumbItem>
                            {index === breadcrumbs.length - 1 ? (
                                crumb.text
                            ) : (
                                <Link 
                                    to={crumb.path} 
                                    className={styles.link}
                                    onClick={() => handleNavigate(crumb.path)}
                                >
                                    {crumb.text}
                                </Link>
                            )}
                        </BreadcrumbItem>
                    </React.Fragment>
                ))}
            </Breadcrumb>
        </nav>
    );
};